module.exports = __webpack_public_path__ + "static/media/29ADMSPC25.ef9700bb.jpg";